import { useEffect } from "react";

export default function useMetaScrollDepth() {
  useEffect(() => {
    const threshold = 75;
    const sessionKey = "meta_scroll_75_fired";

    const hasFired = () => {
      try {
        return sessionStorage.getItem(sessionKey) === "true";
      } catch {
        return false;
      }
    };

    const markFired = () => {
      try {
        sessionStorage.setItem(sessionKey, "true");
      } catch {
        // ignore storage errors
      }
    };

    const track = () => {
      if (hasFired()) return;
      if (!window.fbq) return;

      markFired();

      window.fbq("trackCustom", "ScrollDepth", {
        percent: threshold,
        page_path: window.location.pathname,
      });
    };

    const checkScroll = () => {
      const doc = document.documentElement;
      const scrollTop = window.scrollY || doc.scrollTop || 0;
      const scrollHeight = doc.scrollHeight - window.innerHeight;

      if (scrollHeight <= 0) return;

      const scrolled = Math.round((scrollTop / scrollHeight) * 100);

      if (scrolled >= threshold) {
        track();
      }
    };

    let ticking = false;

    const onScroll = () => {
      if (ticking) return;
      ticking = true;

      requestAnimationFrame(() => {
        checkScroll();
        ticking = false;
      });
    };

    checkScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("load", checkScroll);

    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("load", checkScroll);
    };
  }, []);
}